
























































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class HelpChVimeoRegister extends Vue {
  selectedIndex: number = 0;
  mounted() {
    if (Object.keys(this.$route.params).includes('type')) {
      if (this.$route.params.type === 'ch') {
        this.selectedIndex = 0;
      } else if (this.$route.params.type === 'vod') {
        this.selectedIndex = 1;
      }
    }
  }
}
